import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    resetErrors: null,
    setError: ['error', 'errorDetail']
})

export const ErrorTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
    error: null,
    errorDetail: null
})

/* ------------- Reducers ------------- */
export const errorResetErrors = (state) => INITIAL_STATE

export const errorSetError = (state, { error, errorDetail }) =>
    state.merge({ error, errorDetail: errorDetail || '' })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.RESET_ERRORS]: errorResetErrors,
    [Types.SET_ERROR]: errorSetError
})